/**
 * All4Flat — Drawer móvil JS
 * Maneja: toggle del drawer, submenús acordeón, cierre con Escape.
 */

/* ── TOGGLE SUBMENÚ ─────────────────────────────────────────────── */
window.a4fToggleSub = function(btn) {
  const isOpen = btn.getAttribute('aria-expanded') === 'true';
  const sub    = btn.nextElementSibling; // .a4f-drawer__sub

  // Cierra todos los demás abiertos
  document.querySelectorAll('.a4f-drawer__link--parent[aria-expanded="true"]').forEach(b => {
    if (b !== btn) {
      b.setAttribute('aria-expanded', 'false');
      const s = b.nextElementSibling;
      if (s) { s.setAttribute('aria-hidden', 'true'); }
    }
  });

  // Abre / cierra el actual
  btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  if (sub) sub.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
};

/* ── CIERRE CON ESCAPE ──────────────────────────────────────────── */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    const drawer = document.querySelector('.a4f-drawer');
    if (drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
    }
  }
});

/* ── TRAMPA DE FOCO (accesibilidad) ─────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.a4f-drawer');
  if (!drawer) return;

  const focusableSelectors = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  drawer.addEventListener('keydown', e => {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    const focusable = [...drawer.querySelectorAll(focusableSelectors)];
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Mueve el foco al drawer al abrirlo
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.attributeName === 'class' && drawer.classList.contains('is-open')) {
        const closeBtn = drawer.querySelector('.a4f-drawer__close');
        if (closeBtn) closeBtn.focus();
      }
    });
  });
  observer.observe(drawer, { attributes: true });
});